import React from 'react';

export default function LoadingSpinner({ message = "Laster...", overlay = false }) {
  const content = (
    <div className="flex flex-col items-center justify-center gap-8 text-[#3B4D3C]">
      <div className="w-16 h-16 border-4 border-[#3B4D3C] border-t-transparent rounded-full animate-spin"></div>
      <p className="font-serif italic text-2xl">{message}</p>
    </div>
  );

  if (overlay) {
    return (
      <div className="fixed inset-0 z-[200] bg-[#F8F5F0]/85 backdrop-blur-md flex items-center justify-center">
        {content}
      </div>
    );
  }

  return (
    <div className="py-32 flex items-center justify-center">
      {content}
    </div>
  );
}